import { render, staticRenderFns } from "./VerifyDocument.vue?vue&type=template&id=1f5151d4"
import script from "./VerifyDocument.vue?vue&type=script&lang=js"
export * from "./VerifyDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports